import gql from 'graphql-tag';

export const createCommercialFacility = gql`
  mutation createCommercialFacility($input: CommercialFacilityInput!) {
    createCommercialFacility(input: $input) {
      id
      companyId
      facilityName
      facilityTypeId
      facilityId
      mcFacilityId
      marketAreaId
      facilityLineSegment
      aorId
      numberOfUnits
      owner
      operator
      fuelManager
      balancingTypeId
      contract
      rateableTake
      criticalDay
      createdAt
      createdBy
      updatedAt
      updater
      deletedAt
      version
      Company {
        id
        name
      }
      FacilityType {
        id
        name
      }
      OperatingArea {
        id
        name
      }
      MarketArea {
        id
        name
        operatingAreaId
      }
      AOR {
        id
        name
      }
      gcSupervisor {
        id
        firstName
        lastName
      }
      gcManager {
        id
        firstName
        lastName
      }
      BalancingType {
        id
        name
      }
      Contacts {
        id
        firstName
        lastName
        companyId
        jobRoleId
        deskPhone
        mobilePhone
        emailAddress
        ice
        createdAt
        createdBy
        updatedAt
        updater
        deletedAt
        version
        Company {
          id
          name
        }
        JobRole {
          id
          name
        }
      }
    }
  }
`;
